// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals'; // <-- DECOMMENTA QUESTA
import { BrowserRouter } from 'react-router-dom';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // <-- COMMENTA QUESTA

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// 2. MODIFICA QUESTA RIGA
// serviceWorkerRegistration.register(); // <-- COMMENTA O ELIMINA QUESTA RIGA
reportWebVitals(); // <-- RIPRISTINA QUESTA